(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LogType', LogType);

    LogType.$inject = ['$resource', 'DateUtils'];

    function LogType ($resource, DateUtils) {
        var resourceUrl =  'api/log-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllLogTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/log-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getlogtypebyname = function (data,callback){
		$http.get('api/log-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogTypeSearch', LogTypeSearch);

    LogTypeSearch.$inject = ['$resource'];

    function LogTypeSearch ($resource) {
        var service = $resource('/api/log-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomLogTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-log-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();